import { PHONE_DIALING_CODE } from '../constants';

/**
 * Convertit un numéro saisi (national ou international) au format E.164, avec l'indicatif du pays de la boutique
 * pour un numéro national. Les séparateurs (espaces, points, tirets) sont retirés.
 * Ex : "06 12 34 56 78" => "+33612345678" (FR), "0475 12 25 12" => "+32475122512" (BE), "0032475122512" => "+32475122512"
 * @param {String} phoneNumber
 * @returns {String}
 */
export const toInternationalPhoneNumber = phoneNumber => {
    if (!phoneNumber) {
        return phoneNumber;
    }
    let number = phoneNumber.replace(/[\s.-]/g, '');
    if (number.startsWith('00')) {
        number = `+${number.substring(2)}`;
    }
    if (!number.startsWith('+')) {
        number = `${PHONE_DIALING_CODE}${number.startsWith('0') ? number.substring(1) : number}`;
    }
    return number;
};



// WEBPACK FOOTER //
// ./src/utils/phoneUtils.js